'use client';
import React, { useState } from 'react';
import TechSections from './TechSections';

const TechStack = ({ techData }) => {
  const [shift, setShift] = useState(false);

  const webFrameworks = techData?.section2_contents?.filter(
    (tech) => tech.development_platform_id.key === 'Web'
  ) ?? [[]];
  const mobileFrameworks = techData?.section2_contents?.filter(
    (tech) => tech.development_platform_id.key === 'Mobile'
  ) ?? [[]];

  return (
    <div className="techStack w-full flex px-4 flex-col gap-8 md:gap-12 items-center justify-center py-8">
      <div className="w-full text-center flex flex-col gap-6 items-center justify-center">
        <h2 className="text-3xl md:text-4xl font-bold text-white tracking-tight">
          {techData?.section2_heading ?? 'How we develop for'}
        </h2>
        
        {/* Premium Glassmorphic Toggle Container */}
        <div className="relative flex items-center justify-center p-1 rounded-xl bg-[#020C0D]/80 border border-[#0C3438] w-64 h-12 shadow-[0_4px_20px_rgba(0,0,0,0.4)] backdrop-blur-sm">
          {/* Sliding Indicator Pill */}
          <div
            className={`absolute top-1 bottom-1 left-1 w-[calc(50%-4px)] rounded-lg bg-gradient-to-r from-[#1FBCCB] to-[#32C5D6] shadow-[0_0_15px_rgba(31,188,203,0.3)] transition-all duration-300 ease-out ${
              shift ? 'translate-x-full' : 'translate-x-0'
            }`}
          ></div>
          
          {/* Web Button */}
          <div
            onClick={() => setShift(false)}
            className={`z-20 flex items-center justify-center w-[50%] h-full font-semibold transition-colors duration-300 cursor-pointer text-sm ${
              shift ? 'text-gray-400 hover:text-white' : 'text-black'
            }`}
          >
            Web
          </div>
          
          {/* Mobile Button */}
          <div
            onClick={() => setShift(true)}
            className={`z-20 flex items-center justify-center w-[50%] h-full font-semibold transition-colors duration-300 cursor-pointer text-sm ${
              shift ? 'text-black' : 'text-gray-400 hover:text-white'
            }`}
          >
            Mobile
          </div>
        </div>
      </div>

      <TechSections
        shift={shift}
        webFrameworks={webFrameworks}
        mobileFrameworks={mobileFrameworks}
      />
    </div>
  );
};

export default TechStack;
